import { useStrings } from "features/i18n/useStrings";
import strings from "./ReadOnlyInput.strings";
import "./ReadOnlyInput.less";
import { GuxIcon, GuxTruncate } from "genesys-spark-components-react";
import { MarkdownInline } from "./Markdown";
import { GuxIconIconName } from "genesys-spark-components";

export function ReadOnlyInput({
    icon,
    label,
    screenreaderText,
}: {
    icon: GuxIconIconName;
    label?: string;
    screenreaderText: string;
}) {
    return (
        <div className="ReadOnlyInput">
            <div className="read-only-input-icon">
                <GuxIcon
                    iconName={icon}
                    screenreader-text={screenreaderText}
                    data-testid={icon}
                />
            </div>
            {label && (
                <div className="read-only-input-label">
                    <GuxTruncate max-lines={15}>
                        <MarkdownInline
                            markdownInlineText={label ?? ""}
                        ></MarkdownInline>
                    </GuxTruncate>
                </div>
            )}
        </div>
    );
}

export function ReadOnlyRadio({
    checked,
    label,
}: {
    checked?: boolean;
    label?: string;
}) {
    const t = useStrings(strings);
    return (
        <ReadOnlyInput
            icon={checked ? "radio-active" : "radio"}
            label={label}
            screenreaderText={
                t.screenreader.radio[checked ? "active" : "inactive"]
            }
        />
    );
}

export function ReadOnlyCheckbox({
    checked,
    label,
}: {
    checked?: boolean;
    label?: string;
}) {
    const t = useStrings(strings);
    return (
        <ReadOnlyInput
            icon={checked ? "checkbox-active" : "checkbox"}
            label={label}
            screenreaderText={
                t.screenreader.checkbox[checked ? "selected" : "unselected"]
            }
        />
    );
}
